/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)


// axios
import axios from "axios"
Vue.prototype.$http = axios

// VeeValidate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')

// persian date
import PDatePicker from 'vue2-persian-datepicker'
Vue.component('pdatepicker', PDatePicker)

// import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
// Vue.component('date-picker', VuePersianDatetimePicker);
// Vue.use(VuePersianDatetimePicker, {
//   name: 'custom-date-picker',
//   props: {
//     inputFormat: 'YYYY-MM-DD',
//     format: 'jYYYY-jMM-jDD',
//     editable: false,
//     inputClass: 'date_custom',
//     placeholder: 'تاریخ مورد نظر را انتخاب نمایید',
//     altFormat: 'YYYY-MM-DD',
//     color: '#00acc1',
//     autoSubmit: false,
//     //...  
//     //... And whatever you want to set as default 
//     //... 
//   }
// });

import VuePusher from 'vue-pusher';
import Pusher from 'pusher-js';
Pusher.logToConsole = true;
Vue.use(VuePusher, {
  api_key: '04ca5914372c75e40ed7',
  options: {
    cluster: 'eu'
  }
});

Vue.config.productionTip = false

const accessToken = `Bearer ${localStorage.token}`

if (accessToken) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = accessToken
}

new Vue({
    router,
    store,
    axios,
    render: h => h(App)
}).$mount('#app')
